import React, { Component } from 'react'
import { API_URL } from '../Constants';
import AjaxLoader from '../SVG/AjaxLoader';
import TestLinks from './TestLinks';
export default class Login extends Component {

  state = {}

  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.loginOTP =    this.loginOTP.bind(this);
    this.fetchToken = this.fetchToken.bind(this)
  }

  async fetchToken(fetchPromise){
    const res = await fetchPromise;
    const data = await res.json();

    if (data.token !== undefined) {
      this.saveToken(data.token);
      this.props.onLogin(data.token);
      this.setState({isOTPInput:false });
    }else{
      if (data.otp_checks_remaining <=0 ){
        this.setState({ errorMessage: 'Max checks exceeded', isOTPInput:false })
      }
    }
  }

  render() {
    const { token } = this.props;
    const { errorMessage,isOTPInput, isAjax,phone } = this.state;
    const isPhone = phone!==undefined && phone!=='';
    return (
      <div>
        <div className='p-5'>

          {token === null &&
            <>
              {isOTPInput? <form onSubmit={this.loginOTP}>
              <div className="mb-3">
                  <label htmlFor="InputOTP" className="form-label">Verification Code:</label>
                  <input name="verification_code" type="tel"  className="form-control" id="InputOTP"  onChange={(e) => this.setState({ otp: e.target.value })}></input>
                 </div>
                 <button type="submit" className="btn btn-primary">Submit</button>
              </form>:<form onSubmit={this.login} disabled={isAjax} style={{overflow:'hidden'}}>
                {isAjax && <div style={{background:'rgba(255,255,255,.7)','top':0,'left':0,borderRadius:'15px'}} className='d-flex w-100 h-100 justify-content-center align-items-center position-absolute'>
                  <AjaxLoader></AjaxLoader>
                </div>}
                <div className='mb-3'>
                  <label htmlFor="Inputphone" className="form-label">Phone</label>
                  <input type="tel" className="form-control" id="Inputphone" aria-describedby="Inputphone" onChange={(e) => this.setState({ phone: e.target.value })}></input>
                  <div id="Inputphone" className="form-text">Please enter your phone number here to receive verification code.</div>
                
                </div>
                <div style={{ overflow:'hidden', transition:'all .5s',opacity:(isPhone)? 0:1,maxHeight:(isPhone)?'0px':'300px'}}>
                  <p className="text-center text-muted m-0"> OR</p>
                  
                  <div className="mb-3">
                    <label htmlFor="Inputusername1" className="form-label">Username</label>
                    <input type="username" className="form-control" id="Inputusername1"  onChange={(e) => this.setState({ username: e.target.value })}></input>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="InputPassword1" className="form-label">Password</label>
                    <input type="password" className="form-control" id="InputPassword1" onChange={(e) => this.setState({ password: e.target.value })}></input>
                  </div>
                </div>

                {errorMessage && <div className='error text-danger p-2 mb-3'>{errorMessage}</div>}
                <button type="submit" className="btn btn-primary">Submit</button>
              </form>
              }
            </>
          }
          {token !== null && <div>
            Now you are logged in. You can go to:
            <TestLinks></TestLinks>
          </div>}
        </div>
      </div>
    )
  }


  async login(e) {
    this.setState({errorMessage:undefined});
    e.preventDefault();
    console.log(this.state)
    const { username, password, phone } = this.state;
    console.log(phone)
    if (phone !== undefined && phone !== '') {//TODO check pattern
      this.setState({isAjax:true});
      const res = await fetch(`${API_URL}/api/otpauth/send`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone }),
      });
      console.log(res);
      const data = await res.json();
      this.setState({isAjax:false});
      console.log(data);
      console.log(res.status);
      if (res.status !== 200) {
        this.setState({ errorMessage: data.detail })
      } else {
        console.log('isOTPInput');
        this.setState({ isOTPInput: true })
      }

    } else {
      await this.fetchToken(fetch(`${API_URL}/api/tokenauth/`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      }));
      
    }
  }

  async loginOTP(e){
    e.preventDefault();
    this.setState({errorMessage:undefined});
    const { otp ,phone} = this.state;
    let affiliate_id = localStorage.getItem('affiliate_id')
    if (affiliate_id===null) affiliate_id=undefined
    await this.fetchToken(fetch(`${API_URL}/api/otpauth/login`, {
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ otp,phone,affiliate_id }),
    }));
  }

  saveToken(token) {
    localStorage.setItem('access_token', token);
  }

  
}
